import { useEffect, useRef, useState } from 'react';
import { Palette, Check } from 'lucide-react';
import { SKINS, useSkin } from '../../hooks/useSkin';
import { ICE, PANEL, PX_FONT, TEAL, ACCENT, pixelFrame } from './theme';

/** Compact skin menu: one round button, choices in a small popover. */
export function SkinPicker() {
  const { skin, setSkin } = useSkin();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const close = (e: MouseEvent) => { if (!ref.current?.contains(e.target as Node)) setOpen(false); };
    document.addEventListener('mousedown', close);
    return () => document.removeEventListener('mousedown', close);
  }, [open]);
  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <button type="button" aria-haspopup="menu" aria-expanded={open} aria-label="Change skin" title="Skin" onClick={() => setOpen(o => !o)}
        style={{ width: 36, height: 36, borderRadius: '50%', border: 'none', cursor: 'pointer', display: 'grid', placeItems: 'center', background: PANEL, color: open ? ACCENT : TEAL, boxShadow: pixelFrame(open) }}>
        <Palette size={16} />
      </button>
      {open && (
        <div role="menu" style={{ position: 'absolute', right: 0, top: 44, zIndex: 50, minWidth: 160, padding: 6, background: PANEL, boxShadow: pixelFrame(true), borderRadius: 'var(--pal-radius, 0)' }}>
          {SKINS.map(s => (
            <button key={s.id} type="button" role="menuitemradio" aria-checked={s.id === skin} onClick={() => { setSkin(s.id); setOpen(false); }}
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, padding: '8px 10px', border: 'none', cursor: 'pointer', background: 'none', fontFamily: PX_FONT, fontSize: 12, color: s.id === skin ? ACCENT : ICE, textAlign: 'left' }}>
              {s.name}{s.id === skin && <Check size={14} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
